import { from, split } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'
import { createUploadLink } from 'apollo-upload-client'

import {
  createAuthLink,
  createRefreshTokenApolloErrorLink,
  createWebsocketLink,
} from '../helpers'

class ApolloRootLink {
  constructor({ httpUri, subscriptionUri }) {
    this.httpUri = httpUri
    this.subscriptionUri = subscriptionUri

    const webSocketLink = createWebsocketLink(this.subscriptionUri, () => false)

    const splitLink = split(
      ({ query }) => {
        const definition = getMainDefinition(query)
        return (
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'subscription'
        )
      },
      webSocketLink,
      createUploadLink({
        uri: httpUri,
      }),
    )

    this.link = splitLink
  }

  addAccessTokenToHeaders(getAccessToken, getNewAccessToken) {
    const authLink = createAuthLink(getAccessToken)

    const refreshTokenErrorLink =
      createRefreshTokenApolloErrorLink(getNewAccessToken)

    const webSocketLink = createWebsocketLink(
      this.subscriptionUri,
      getAccessToken,
    )

    const httpLink = from([
      refreshTokenErrorLink,
      authLink,
      createUploadLink({
        uri: this.httpUri,
      }),
    ])

    const splitLink = split(
      ({ query }) => {
        const definition = getMainDefinition(query)
        return (
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'subscription'
        )
      },
      webSocketLink,
      httpLink,
    )

    this.link = splitLink
  }

  removeAccessTokenFromHeaders() {
    this.link = createUploadLink({
      uri: this.httpUri,
    })
  }
}

export default ApolloRootLink
